module.exports = __webpack_public_path__ + "band_13_son.0d63ef10.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_13_son.png
// module id = jqxi
// module chunks = 0